// Hypothesis Engine — feature gate (pure logic). DEFAULT OFF (in development).
// Precedence: local kill → VITE_HYPOTHESIS_ENGINE env → local opt-in → off.
// Mirrors validationEngineFlag.ts.

import { publicEnv } from './clientEnv';

export type HypothesisGate = { enabled: boolean; reason: string };

export const HYPOTHESIS_ENGINE_OPTIN_KEY = 'hypothesis_engine_optin';
export const HYPOTHESIS_ENGINE_KILL_KEY = 'hypothesis_engine_kill';

function ls(key: string): string | null {
  try { return typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null; } catch { return null; }
}

export function hypothesisEngineGate(): HypothesisGate {
  const on = (reason: string): HypothesisGate => ({ enabled: true, reason });
  const off = (reason: string): HypothesisGate => ({ enabled: false, reason });

  if (ls(HYPOTHESIS_ENGINE_KILL_KEY) === '1') return off('local_kill');
  const e = (publicEnv('VITE_HYPOTHESIS_ENGINE') ?? '').toLowerCase();
  if (e === 'on') return on('env_on');
  if (e === 'off') return off('disabled_globally');
  if (ls(HYPOTHESIS_ENGINE_OPTIN_KEY) === '1') return on('local_optin');
  return off('default_off');
}

export function engageHypothesisEngine(on: boolean): void {
  try {
    if (on) localStorage.setItem(HYPOTHESIS_ENGINE_OPTIN_KEY, '1');
    else localStorage.removeItem(HYPOTHESIS_ENGINE_OPTIN_KEY);
  } catch { /* ignore */ }
}
